// Login request response
export const LOGIN_RESPONSE_TYPE = {
    ACCEPT_TERMS: 'accept_terms',
    ACCEPT_TERMS_ADVERTISING: 'USR_REG_00004',
    USER_LOGIN_CAPTCHA_REQUIRED: 'user_login_captcha_required',
    SHOW_LOGIN_ERROR: 'show_login_error',
    GO_IP_TELMEX: 'go_ip_telmex',
    NONE: 'none'
};

/**
 * Login
 */
export const LOGIN_EMAIL = 'email';
export const LOGIN_NET = 'net';
export const LOGIN_HDTV = 'hdtv';

/**
 * Analytics.
 */
// Register.
export const REGISTRY_EVENT_ACTION = 'Registro';
export const REGISTRY_EVENT_CATEGORY = 'Home';
export const REGISTRY_EVENT_SUCCESS_LABEL = 'Exitoso Landing-Usuario y contraseña';
export const REGISTRY_EVENT_ERROR_LABEL_PREFIX = 'RegistroUsuarioYContraseña';
export const ISREGISTER = true;

// Login.
export const LOGIN_EVENT_ACTION = 'Inicia sesión';
export const LOGIN_EVENT_CATEGORY = 'Home';
export const LOGIN_EVENT_LABEL = 'Usuario y contraseña';
export const LOGIN_EVENT_SUCCESS_LABEL = 'Exitoso Usuario y contraseña';
export const LOGIN_EVENT_ERROR_LABEL_PREFIX = 'InicioSesiónUsuarioYContraseña';

// Password reminder.
export const PASSWORD_REMINDER_EVENT_ACTION = 'Inicia Sesión';
export const PASSWORD_REMINDER_EVENT_CATEGORY = 'Home';
export const PASSWORD_REMINDER_EVENT_ABORT_LABEL = 'Olvidaste tu contraseña - Cancelar';
export const PASSWORD_REMINDER_EVENT_SUCCESS_LABEL = 'Olvidaste tu contraseña - Aceptar';
export const PASSWORD_REMINDER_EVENT_ERROR_LABEL_PREFIX = 'Olvidaste tu contraseña';

// Metrics modals.
export const TITLE_MODAL_PROMOTIONS = 'Claro video - Promociones Telcel y Telmex';
export const TITLE_MODAL_TERM_AND_CONTIONS = 'Claro video - Condiciones de uso para México';

// SuspendedcAccount.
export const STATUS_ACCOUNT_UNDEFINED = 'undefined';
export const STATUS_ACCOUNT_SUSPENDED = 'suspended';
export const STATUS_ACCOUNT_OK = 'OK';




// WEBPACK FOOTER //
// ./src/AAF/Auth/authConstants.js